import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { Cookie } from 'ng2-cookies/ng2-cookies';

@Injectable()
export class AuthGaurdService implements CanActivate {

  constructor(public router: Router) {}
  canActivate() {
    var user = Cookie.get('token');
    if (!user) {
      this.router.navigate(['login']);
      return false;
    } else {
      // this.router.navigate(['dispatcher']);
      return true;
    }
  }
}


// WEBPACK FOOTER //
// F:/Karry/Zoom/ZoomCustomer/src/app/auth-gaurd.service.ts